// @flow

import { Component, type Node } from 'react';

type Props = {
  delay: number,
  children: Node,
};

type State = {
  timedOut: boolean,
};

export default class Delay extends Component<Props, State> {
  timeoutId: TimeoutID;

  static defaultProps = {
    delay: 1000,
  };

  state = {
    timedOut: false,
  };

  componentDidMount() {
    this.timeoutId = setTimeout(() => {
      this.setState({ timedOut: true });
    }, this.props.delay);
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  render() {
    return this.state.timedOut && this.props.children;
  }
}
